<template>
   <el-popover
			v-if="!_gHlp.isEmpty(tat_summary) && !_gHlp.isEmpty(tat_summary.tat_at)"
			placement="top-start" title="Date Tracking" trigger="hover">
			<p v-if="_gHlp.isEmpty(tat_summary.tat_stop_at)">
					<small class="mb-0 d-block">Last Update : {{ tat_summary.tat_at |
							dateFormatString }}</small>
					<small class="mb-0 d-block"
							:style="{ 'color': tat_summary.tat_color }">Due Date :
							{{ tat_summary.due_at | dateFormatString }}</small>
					<small class="mb-0 d-block"
							:style="{ 'color': tat_summary.tat_color }">{{
									tat_summary.remain_label }}</small>
			</p>
			<p v-else>
					<small class="mb-0 d-block">Create Date : {{ tat_summary.tat_created_at | dateFormatString }}</small>
					<small class="mb-0 d-block">Stop Date : {{ tat_summary.tat_stop_at | dateFormatString }}</small>
					<small class="mb-0 d-block"><strong>TOTAL : {{ tat_summary.tat_total }} Days</strong></small>
			</p>
			<i slot="reference" class="el-icon-info"
					:style="{ 'color': tat_summary.tat_color }"></i>
	</el-popover>
</template>
<script>
	import { Popover } from 'element-ui'
  export default {
		props: ['tat_summary'],
    name: 'tat-date-popover',
		components:{
			[Popover.name]: Popover,
		},
    data() {
      return {
        card: {
          status: 'Active',
          statusType: 'success',
          title: 'john.snow@gmail.com',
          name: 'John Snow'
        }
      }
    }
  }
</script>
